import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";

@Component({
    selector: 'note-confirm-dialog',
    templateUrl: './noteDeleteDialog.component.html',
    styleUrls: ['./noteDeleteDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NoteDeleteDialogComponent {
    action: string;
    dialogTitle: string;

    constructor(
        public matDialogRef: MatDialogRef<NoteDeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
    }
}
